import React from 'react'
import {Hint, RemoveIcon} from 'rambler-ui'
import ProfileItem from 'components/ProfileItem'
import RowButton from 'components/RowButton'
import styles from './styles.css'

export default function WebAuthnKey({title, browser, deleteCredential}) {
  return (
    <ProfileItem
      rightIcon={
        <RowButton
          label="Удалить электронный ключ"
          onClick={deleteCredential}
          data-cerber-id="profile::webauthn::delete_webauthn"
        >
          <RemoveIcon />
        </RowButton>
      }
    >
      <div className={styles.root}>
        {title}
        <Hint className={styles.hint}>
          Вы создали электронный ключ в {browser}
        </Hint>
      </div>
    </ProfileItem>
  )
}
